module.exports = __webpack_public_path__ + "07d869428e62ab4aebed79a0ddfa23bc.pdf";